import { render, staticRenderFns } from "./SalesNewCustomerTable.vue?vue&type=template&id=2978e0bc"
import script from "./SalesNewCustomerTable.vue?vue&type=script&lang=ts"
export * from "./SalesNewCustomerTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports